module.exports = __webpack_public_path__ + "toolkit-static/img/audio_default.279bc3fc.png";